export default "__VITE_ASSET__BEHHXjua__"